import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=6be2b3f7&scoped=true&"
import script from "./InputSearch.vue?vue&type=script&lang=js&"
export * from "./InputSearch.vue?vue&type=script&lang=js&"
import style0 from "./InputSearch.vue?vue&type=style&index=0&id=6be2b3f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2b3f7",
  null
  
)

export default component.exports